/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Not_Route_PlannerInputs */

const fr_help_not_route_planner = /** @type {(inputs: Help_Not_Route_PlannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un calculateur d'itinéraire d'un point A vers un point B.`)
};

const en_help_not_route_planner = /** @type {(inputs: Help_Not_Route_PlannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A route planner from point A to point B.`)
};

/**
* | output |
* | --- |
* | "A route planner from point A to point B." |
*
* @param {Help_Not_Route_PlannerInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_not_route_planner = /** @type {((inputs?: Help_Not_Route_PlannerInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Not_Route_PlannerInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_not_route_planner(inputs)
	return en_help_not_route_planner(inputs)
});